import { useQuery } from "react-query";
import { API_KEY_GET_PROGRAM_STATUSES } from "../utils";
import { getProgramStatuses } from "../api";

export const useGetProgramStatuses = () => {
  return useQuery([API_KEY_GET_PROGRAM_STATUSES], () => getProgramStatuses());
};
